import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Program, UIDispatch} from '../../../domain/cloud-topology';
import {forkJoin, Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {ProgramService} from '../../../services/vpp/program.service';
import {performanceTarget, pointOfMeasurement, programTypes} from '../../../domain/constants';
import {ResourceService} from '../../../services/resource.service';
import {BaseRefreshComponent} from '../../shared/base-refresh/base-refresh.component';

@Component({
    selector: 'app-program-details',
    templateUrl: './program-details.component.html',
    styleUrls: ['./program-details.component.scss'],
    standalone: false
})
export class ProgramDetailsComponent extends BaseRefreshComponent implements OnInit, OnChanges {
  @Input() program: Program;
  private subject$: Subject<void>;
  programTypes = [];
  performanceTarget = [];
  pointOfMeasurement = [];
  maxEnergy: number;
  maxOutput: number;
  constructor(private programService: ProgramService) {
    super();
  }

  ngOnInit() {
    this.programTypes = programTypes;
    this.pointOfMeasurement = pointOfMeasurement;
    this.performanceTarget = performanceTarget;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['program']['currentValue'] !== undefined) {
      this.program = changes['program']['currentValue'];
      this.setData();
    }
  }

  setData(): void {
    if (this.program) {
      this.program.properties.nominatedKw = +UIDispatch.cleanNumericOutput(+this.program.properties.nominatedKw);
      this.program.properties.programPenalty = +UIDispatch.cleanNumericOutput(+this.program.properties.programPenalty);
      this.program.properties.programIncentive = +UIDispatch.cleanNumericOutput(+this.program.properties.programIncentive);

      this.subject$ = new Subject<void>();
      forkJoin([
        this.programService.getMaxOutput(this.program),
        this.programService.getMaxEnergy(this.program),
      ]).pipe(takeUntil(this.subject$)).subscribe(([maxOutput, maxEnergy])  => {
        this.maxOutput = +UIDispatch.cleanNumericOutput(maxOutput);
        this.maxEnergy = +UIDispatch.cleanNumericOutput(maxEnergy);
      }, () => { this.maxOutput = 0; this.maxEnergy = 0; });
    }
  }

  cleanProgramText(key: string, fieldType: string): string {
    return ResourceService.cleanProgramText(key, fieldType);
  }
}
